import { FC } from "react";

import { css, cx } from "@/domains/emotion";
import { MdsDropdownDividerItem } from "@/design-system/components/dropdown";
import styled from "@emotion/styled";

export interface MdsDropdownDividerItemComponentProps {
  className?: string;
  item: MdsDropdownDividerItem;
}

const wrapperStyles = css({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  justifyContent: "center",
  padding: "4px 6px",
});

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.border.default};
`;

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsDropdownDividerItemComponent: FC<MdsDropdownDividerItemComponentProps> = ({
  className,
  item,
}) => {
  return (
    <div className={cx(className, wrapperStyles, item.className)}>
      <Divider />
    </div>
  );
};
